export const getPromotionConfig = ({ promotions, hasEventStarted }) => {
    if (!promotions || !promotions.enabled) {
        return null;
    }

    if (hasEventStarted && promotions.duringEvent?.enabled) {
        return promotions.duringEvent;
    }

    if (!hasEventStarted && promotions.preEvent?.enabled) {
        return promotions.preEvent;
    }

    return null;
};

export const getSelectionPromotionConfig = ({ promotions }) => {
    if (!promotions || !promotions.enabled || !promotions.selection?.enabled) {
        return {
            enabled: false,
            eventPath: null
        };
    }

    return promotions.selection;
};
